import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ProjectsRoomTypes =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ProjectsRoomTypes, _BaseData);

  function ProjectsRoomTypes() {
    _classCallCheck(this, ProjectsRoomTypes);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProjectsRoomTypes).call(this, "ProjectsRoomTypes"));
  }

  _createClass(ProjectsRoomTypes, [{
    key: "GetProjectRoomTypeList",
    value: function () {
      var _GetProjectRoomTypeList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(projectId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("api/".concat(this._controller, "/GetProjectRoomTypeList/").concat(projectId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetProjectRoomTypeList(_x) {
        return _GetProjectRoomTypeList.apply(this, arguments);
      }

      return GetProjectRoomTypeList;
    }()
  }, {
    key: "GetOrCreateProjectRoomType",
    value: function () {
      var _GetOrCreateProjectRoomType = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(projectId, numberOfBedrooms) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("api/".concat(this._controller, "/GetOrCreateProjectRoomType/").concat(projectId, "/").concat(numberOfBedrooms)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetOrCreateProjectRoomType(_x2, _x3) {
        return _GetOrCreateProjectRoomType.apply(this, arguments);
      }

      return GetOrCreateProjectRoomType;
    }()
  }, {
    key: "GetRoomTypesByProjectId",
    value: function () {
      var _GetRoomTypesByProjectId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(projectId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("api/".concat(this._controller, "/GetRoomTypesByProjectId/").concat(projectId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetRoomTypesByProjectId(_x4) {
        return _GetRoomTypesByProjectId.apply(this, arguments);
      }

      return GetRoomTypesByProjectId;
    }()
  }]);

  return ProjectsRoomTypes;
}(BaseData);

export default new ProjectsRoomTypes();